import pino, { Bindings, DestinationStream, LoggerOptions } from 'pino'

export function initLogger(
  ns: string,
  bindings: Bindings = {},
  optionsOrStream: LoggerOptions | DestinationStream = {}
) {
  return pino({ name: ns, ...optionsOrStream }).child({ ns, ...bindings })
}
